import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const Referrer = () => {
  return <ObsIframe path="/referrer" />;
};

export default React.memo(Referrer);
